import React from 'react'

import { theme } from '@hhgtech/hhg-components'

import type { IconProps } from './types'

const Warning: React.FC<IconProps> = ({
  size = 24,
  color = theme.colors.yellow600,
  ...rest
}) => {
  return (
    <svg
      width={size}
      height={size * (25 / 24)}
      fill="none"
      viewBox="0 0 24 25"
      {...rest}
    >
      <path
        fill={color}
        d="M22.24 18.875L13.441 4.24A1.669 1.669 0 0012 3.424c-.596 0-1.135.305-1.44.815L1.76 18.875a1.684 1.684 0 001.442 2.549h17.595a1.683 1.683 0 001.441-2.55zm-9.74-.451h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5zm-.5-4a1 1 0 01-1-1v-3a1 1 0 012 0v3a1 1 0 01-1 1z"
      ></path>
    </svg>
  )
}

export default Warning
